import { render } from "./OperariosPage.vue?vue&type=template&id=6a67310f"
import script from "./OperariosPage.vue?vue&type=script&lang=js"
export * from "./OperariosPage.vue?vue&type=script&lang=js"

import "./OperariosPage.vue?vue&type=style&index=0&id=6a67310f&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__